export const trackersSnapchatPixel = {
  loaded: false,
  enabled: false,

  // Load Snapchat Pixel and begin tracking.
  // Note, if your juristiction requires prior consent before tracking technologies are used,
  // then you should have obtained consent BEFORE you call this method!

  load: function(snapchatPixelId) {
    if (!this.loaded) {
      console.log("Loading scripts and enabling Snapchat Pixel");

      // See https://businesshelp.snapchat.com/en-US/a/pixel-website-install#GeneratePixelCode
      (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
      {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
      a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;
      r.src=n;var u=t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r,u);})(window,document,
      'https://sc-static.net/scevent.min.js');
      snaptr('init', snapchatPixelId, {
      });
      snaptr('track', 'PAGE_VIEW');

      this.loaded = true;
      this.enabled = true;
    } else {
      console.log("Snapchat Pixel scripts already loaded - re-enabling");
      this.enabled = true;
    }
  },

  // Revoke consent for this user to be tracked by Snapchat Pixel
  revokeConsent: function() {
    if (!this.loaded) {
      console.log("Disabling Snapchat Pixel - scripts not loaded yet anyway");
      this.enabled = false;
    } else {
      console.log("Disabling Snapchat Pixel");
      this.enabled = false;
    }
  }
};
